import type { ValueGetterParams } from 'ag-grid-community';
import type { SteelMaker } from '../../types/common';
import type { OrganizationUserType, UserWithOrganizationType } from '../../types/user';

/**
 * ユーザが所属する組織を調べて鉄鋼メーカー一覧を返す
 * @param [ValueGetterParams]
 * @returns [SteelMaker[]] - 商社コードの配列
 */
const steelMakerValueGetter = (params: ValueGetterParams): string[] => {
  const data: UserWithOrganizationType = params.data;
  const organizations: OrganizationUserType[] | undefined = data.organizations;
  // console.log(organizations);
  const steelMakers: SteelMaker[] = organizations
    ? organizations.reduce((acc, cur) => {
        const sum: SteelMaker[] = cur.steelMaker ? [...acc, ...cur.steelMaker] : [...acc];
        return sum;
      }, [])
    : [];
  const filteredSteelMakers: SteelMaker[] = Array.from(new Set(steelMakers));
  // console.log(filteredSteelMakers);
  return filteredSteelMakers;
};

export default steelMakerValueGetter;
